export const getBuildId = () => {
  return process.env.CONFIG_BUILD_ID
}
